import { getAllConditionEntries, getDependencyTaskId, getDependencyBranch } from '../../../shared/ConditionsDropdown/utils/conditionHelpers';

/**
 * Dependency info for a task (taskId and branch).
 * Uses unlockConditions if present (v1 or v2), otherwise falls back to dependsOn.
 */
export function getEffectiveDependencies(task, tasks) {
  const entries = getAllConditionEntries(task.unlockConditions, tasks);
  if (entries.length > 0) return entries;
  const deps = Array.isArray(task.dependsOn) ? task.dependsOn : [];
  return deps.map(dep => ({
    taskId: getDependencyTaskId(dep),
    branch: getDependencyBranch(dep),
  })).filter(d => d.taskId);
}

/**
 * Map of children for each task.
 * Returns { taskId -> [{ childId, branch }] }
 */
export function buildChildrenMap(tasks) {
  const childrenMap = new Map();
  tasks.forEach(t => childrenMap.set(t.id, []));

  tasks.forEach(task => {
    const deps = getEffectiveDependencies(task, tasks);
    deps.forEach(({ taskId: parentId, branch }) => {
      if (childrenMap.has(parentId)) {
        childrenMap.get(parentId).push({ childId: task.id, branch });
      }
    });
  });

  return childrenMap;
}
